import styled from 'styled-components'
import Input from '../Input'
import { LabelProps } from './interface'

export const Radio = styled(Input).attrs({ type: 'radio', className: 'radio' })`
  height: 52px;
  cursor: pointer;
  position: absolute;
  opacity: 0;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
`

export const Wrapper = styled.div`
  position: relative;

  .radio:checked + .label {
    border: ${({ theme }) => theme.border.width.thinner}
      ${({ theme }) => theme.border.style.solid}
      #0769DA;
    background: #C6E2F9;
    color: #0769DA;
  }

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.km4};
  }
`

export const Label = styled.label.attrs({ className: 'label' })<LabelProps>`
  background: ${({ theme }) => theme.neutral.background.default};
  border: ${({ theme }) => theme.border.width.thinner} solid
    ${({ theme }) => theme.neutral.border.default};
  box-sizing: border-box;
  box-shadow: ${({ theme }) => theme.elevation.ton4};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  height: 52px;
  font-style: normal;
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.m2};
  color: ${({ theme }) => theme.neutral.text.default};
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
`
